import type { components } from '~/api/OnPremAgentClient/generated-schema'
import OnPremAgentAPI from '../OnPremAgentClient/OnPremAgentAPI'

export type GetValidInstrumentTypesResponse =
  components['schemas']['GetValidInstrumentTypesResponse']

export type InstrumentType = components['schemas']['InstrumentType']
export type Dataset = components['schemas']['Dataset']
export type DefaultSuccessResponse = components['schemas']['DefaultSuccessResponse']
export type DatasetStatus = components['schemas']['DatasetStatus']
export type DatasetFileStatus = components['schemas']['DatasetFileStatus']
export type DatasetFile = components['schemas']['DatasetFile']
export type PaginatedDatasetsResponse =
  components['schemas']['PaginatedDatasetsResponse']
export type MissedDataset = components['schemas']['DatasetMissed']
export type UpdateReviewedDatasetRequest =
  components['schemas']['UpdateReviewedDatasetRequest']

type ListDatasetsParams = {
  page?: number
  pageSize?: number
  plateName?: string | null
}

class DatasetsAPI extends OnPremAgentAPI {
  listDatasets = (params?: ListDatasetsParams): Promise<PaginatedDatasetsResponse> => {
    const { page, pageSize, plateName } = params || {}
    const trimmedPlateName = plateName?.trim()
    return this.client.GET('/api/datasets/', {
      params: {
        query: {
          page,
          page_size: pageSize,
          plate_name: trimmedPlateName ? trimmedPlateName : undefined,
        },
      },
    })
  }
  getDataset = (datasetUuid: string): Promise<Dataset> => {
    return this.client.GET(`/api/datasets/{dataset_uuid}`, {
      params: {
        path: { dataset_uuid: datasetUuid },
      },
    })
  }
  getDatasetFiles = (datasetUuid: string): Promise<DatasetFile[]> => {
    return this.client.GET(`/api/datasets/{dataset_uuid}/files`, {
      params: { path: { dataset_uuid: datasetUuid } },
    })
  }
  validateAllDatasets = (): Promise<Dataset[]> => {
    return this.client.GET('/api/datasets/validate/all')
  }
  retryDataset = (datasetUuid: string): Promise<DefaultSuccessResponse> => {
    return this.client.GET(`/api/datasets/{dataset_uuid}/retry`, {
      params: { path: { dataset_uuid: datasetUuid } },
    })
  }
  listMissedDatasets = (): Promise<MissedDataset[]> => {
    return this.client.GET('/api/datasets/missed/all')
  }

  updateMissedDataset = (
    request: UpdateReviewedDatasetRequest,
  ): Promise<DefaultSuccessResponse> => {
    return this.client.POST(`/api/datasets/missed/update`, {
      body: request,
    })
  }
}

export default DatasetsAPI
